import { apis } from "@/modules/apiClients"
import { workTimeAtom } from "@/store/saveWorkAtoms"
import { useSetAtom } from "jotai"
import _ from "lodash"
import { useCallback, useEffect } from "react"

const eventsToReport = ['focus', 'mousemove', 'keydown', 'scroll', 'focusin']

export const useWorkTimeReporting = (challengeId: string | null) => {
  const setWorkTime = useSetAtom(workTimeAtom)

  const report = useCallback(_.throttle(async () => {
    if (challengeId) {
      const { data } = await apis.challengeService.reportWorkTime({ challengeId })
      if (data.workTime) {
        setWorkTime(data.workTime)
      }
    }
  }, 60_000), [challengeId])

  useEffect(() => {
    // Only add listeners if we have a challengeId
    if (!challengeId) {
      return
    }

    // Add event listeners
    eventsToReport.forEach(event => {
      window.addEventListener(event, report)
    })

    // Cleanup function - this runs when challengeId changes OR component unmounts
    return () => {
      eventsToReport.forEach(event => {
        window.removeEventListener(event, report)
      })
    }
  }, [report, challengeId]) // This effect re-runs when challengeId changes
}